export const GetLimitedCompanyQuestions = () => {

    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
    const questionsJSON = [
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "50"
            },
            "questionSetQuestion": {
                "questionID": 1,
                "text": "Who is the business contact?",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": "This would be the person who we speak with in regards to the business insurance",
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            /*"placeholder": "Please type the business contacts name"*/
            "placeholder": "Name of the business contact"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "50"
            },
            "questionSetQuestion": {
                "questionID": 2,
                "text": "What is the business name?",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Business name"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 15,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 15,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 4,
                "text": "Please enter the correspondence postcode, and then click search",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 15,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 15,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 5,
                        "text": "House",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 6,
                        "text": "Street",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 7,
                        "text": "Town",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 8,
                        "text": "City",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 9,
                        "text": "Country",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 10,
                        "text": "County",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 11,
                        "text": "Postcode",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                }
            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Business postcode & click search"
        },
        {
            "answer": userData !== null ? userData.email : null,
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": /^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 12222,
                "text": "What is the email address?",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "Please enter a valid email address",
            "placeholder": "Business email address"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "number",
                "answerTypeBaseTypeID": 3,
                "regex": /^\s*\(?((\+0?44)?\)?[ \-]?(\(0\))|0)((20[7,8]{1}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{4})|([1-8]{1}[0-9]{3}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{3}))\s*$/,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 13,
                "text": "What is the primary contact telephone number?",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "Please enter a valid contact number",
            "placeholder": "Business contact number"
        }
    ];

    return questionsJSON;
}


export const GetPartnershipQuestions = () => {
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;

    var dateStart = new Date();
    dateStart.setFullYear(dateStart.getFullYear() - 100);
    let dateStartRange = dateStart.toISOString().split('T')[0];

    var dateEnd = new Date();
    dateEnd.setFullYear(dateEnd.getFullYear() - 18);
    let dateEndRange = dateEnd.toISOString().split('T')[0];

    const questionsJSON = [
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "15"
            },
            "questionSetQuestion": {
                "questionID": 1,
                "text": "Who is the business contact?",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": "This would be the person who we speak with in regards to the business insurance",
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            /*"placeholder": "Please type the business contacts name"*/
            "placeholder": "Name of the business contact"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "50"
            },
            "questionSetQuestion": {
                "questionID": 2,
                "text": "What is the business name?",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Business name"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 2,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 2,
                "regex": null,
                "startRange": dateStartRange,
                "endRange": dateEndRange,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 3,
                "text": "Please complete your date of birth, or the date of birth of one of the company partners",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 9,
                "isParentQuestionIDNull": true,
                "parentQuestionID": 62,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 2,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [
            ],
            "parentQuestionID": 62,
            "answerTypeID": 2,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": ""
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 15,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 15,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 4,
                "text": "Please enter the correspondence postcode, and then click search",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 15,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 15,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 5,
                        "text": "House",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 6,
                        "text": "Street",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 7,
                        "text": "Town",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 8,
                        "text": "City",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 9,
                        "text": "Country",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 10,
                        "text": "County",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 11,
                        "text": "Postcode",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                }
            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Business postcode & click search"
        },
        {
            "answer": userData !== null ? userData.email : null,
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": /^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/,
                "startRange": null,
                "endRange": null,
                "length": "50"
            },
            "questionSetQuestion": {
                "questionID": 12222,
                "text": "What is the email address?",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "Please enter a valid email address",
            "placeholder": "Business email address"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "number",
                "answerTypeBaseTypeID": 3,
                "regex": /^\s*\(?((\+0?44)?\)?[ \-]?(\(0\))|0)((20[7,8]{1}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{4})|([1-8]{1}[0-9]{3}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{3}))\s*$/,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 13,
                "text": "What is the primary contact telephone number?",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "Please enter a valid contact number",
            "placeholder": "Business contact number"
        }
    ];

    return questionsJSON;
}


export const GetSoleTraderQuestions = () => {
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;

    var dateStart = new Date();
    dateStart.setFullYear(dateStart.getFullYear() - 100);
    let dateStartRange = dateStart.toISOString().split('T')[0];

    var dateEnd = new Date();
    dateEnd.setFullYear(dateEnd.getFullYear() - 18);
    let dateEndRange = dateEnd.toISOString().split('T')[0];

    const questionsJSON = [
        {
            "answer": "",
            "sectionName": "Customer Details",
            "parentQuestionID": null,
            "answerTypeID": 0,
            "enabled": false,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": null,
            "questionSetAnswerType": {
                "answerTypeID": 1,
                "answerTypeName": "ListValueID",
                "baseTypeName": "ListValueID",
                "answerTypeBaseTypeID": 1,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": null
            },
            "questionSetQuestion": {
                "questionID": 15,
                "questionSetID": 1,
                "tailorQuoteFlag": false,
                "answerDefaultValueOrID": "",
                "answerDefaultSet": false,
                "answerTypeID": 1,
                "childQuestionRepeatMaximum": null,
                "childQuestionRepeatMinimum": null,
                "developersNotes": null,
                "enabled": true,
                "helpText": null,
                "listTableID": 5,
                "mandatory": true,
                "mandatoryText": null,
                "parentQuestionID": null,
                "quickQuote": true,
                "sectionID": 8,
                "sortOrder": 2,
                "text": "What is your Title?",
                "visible": true
            },
            "answerList": [
                {
                    "text": "Doctor",
                    "value": "001",
                    "selected": false
                },
                {
                    "text": "Lord",
                    "value": "021",
                    "selected": false
                },
                {
                    "text": "Miss",
                    "value": "002",
                    "selected": false
                },
                {
                    "text": "Mr",
                    "value": "003",
                    "selected": false
                },
                {
                    "text": "Mrs",
                    "value": "004",
                    "selected": false
                },
                {
                    "text": "Ms",
                    "value": "005",
                    "selected": false
                },
                {
                    "text": "Sir",
                    "value": "007",
                    "selected": false
                }
            ],
            "enablementCriteria": [],
            "index": 0,
            "sectionSortOrder": 1,
            "focus": false,
            "validationFail": false,
            "validationMessage": null,
            "page": 0
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "50"
            },
            "questionSetQuestion": {
                "questionID": 1,
                "text": "What is your Forename?",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Your forename"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "50"
            },
            "questionSetQuestion": {
                "questionID": 14,
                "text": "What is your Surname?",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Your surname"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 2,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 2,
                "regex": null,
                "startRange": dateStartRange,
                "endRange": dateEndRange,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 3,
                "text": "Please complete your date of birth, or the date of birth of one of the company partners",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 9,
                "isParentQuestionIDNull": true,
                "parentQuestionID": 62,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 2,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [
            ],
            "parentQuestionID": 62,
            "answerTypeID": 2,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": ""
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 15,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 15,
                "regex": null,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 4,
                "text": "Please enter the correspondence postcode, and then click search",
                "mandatory": true,
                "isHelpTextNull": false,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 15,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 15,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 5,
                        "text": "House",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 6,
                        "text": "Street",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 7,
                        "text": "Town",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 8,
                        "text": "City",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 9,
                        "text": "Country",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 10,
                        "text": "County",
                        "mandatory": false,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                },
                {
                    "answer": "",
                    "sectionName": "About your business",
                    "questionSetAnswerType": {
                        "answerTypeID": 3,
                        "answerTypeName": "",
                        "baseTypeName": "text",
                        "answerTypeBaseTypeID": 3,
                        "regex": null,
                        "startRange": null,
                        "endRange": null,
                        "length": "40"
                    },
                    "questionSetQuestion": {
                        "questionID": 11,
                        "text": "Postcode",
                        "mandatory": true,
                        "isHelpTextNull": true,
                        "helpText": null,
                        "sectionID": 1,
                        "isParentQuestionIDNull": false,
                        "parentQuestionID": 3,
                        "answerDefaultSet": true,
                        "answerDefaultValueOrID": "",
                        "listTableID": 0,
                        "visible": false,
                        "enabled": true,
                        "answerTypeID": 3,
                        "isAnswerDefaultValueOrIDNull": false,
                        "childQuestionRepeatMinimum": 0,
                        "childQuestionRepeatMaximum": 0
                    },
                    "answerList": [

                    ],
                    "parentQuestionID": 3,
                    "answerTypeID": 3,
                    "enabled": true,
                    "hasDependentQuestions": false,
                    "hasChildQuestions": false,
                    "childInformation": [

                    ],
                    "enablementCriteria": [],
                    "index": 0,
                    "focus": false,
                    "page": 0,
                    "validationFail": false,
                    "validationMessage": ""
                }
            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "",
            "placeholder": "Business postcode & search"
        },
        {
            "answer": userData !== null ? userData.email : null,
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "text",
                "answerTypeBaseTypeID": 3,
                "regex": /^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 12222,
                "text": "What is the email address?",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "Please enter a valid email address",
            "placeholder": "Business email address"
        },
        {
            "answer": "",
            "sectionName": "About your business",
            "questionSetAnswerType": {
                "answerTypeID": 3,
                "answerTypeName": "",
                "baseTypeName": "number",
                "answerTypeBaseTypeID": 3,
                "regex": /^\s*\(?((\+0?44)?\)?[ \-]?(\(0\))|0)((20[7,8]{1}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{4})|([1-8]{1}[0-9]{3}\)?[ \-]?[1-9]{1}[0-9]{2}[ \-]?[0-9]{3}))\s*$/,
                "startRange": null,
                "endRange": null,
                "length": "40"
            },
            "questionSetQuestion": {
                "questionID": 13,
                "text": "What is the primary contact telephone number?",
                "mandatory": true,
                "isHelpTextNull": true,
                "helpText": null,
                "sectionID": 1,
                "isParentQuestionIDNull": true,
                "parentQuestionID": null,
                "answerDefaultSet": true,
                "answerDefaultValueOrID": "",
                "listTableID": 0,
                "visible": true,
                "enabled": true,
                "answerTypeID": 3,
                "isAnswerDefaultValueOrIDNull": false,
                "childQuestionRepeatMinimum": 0,
                "childQuestionRepeatMaximum": 0
            },
            "answerList": [

            ],
            "parentQuestionID": null,
            "answerTypeID": 3,
            "enabled": true,
            "hasDependentQuestions": false,
            "hasChildQuestions": false,
            "childInformation": [

            ],
            "enablementCriteria": [],
            "index": 0,
            "focus": false,
            "page": 0,
            "validationFail": false,
            "validationMessage": "Please enter a valid contact number",
            "placeholder": "Business contact number"
        }
    ];

    return questionsJSON;
}